import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { useEffect } from "react";
import { decodeJwt, getAuthCallBackErrorMessage } from "../../utils/authUtils";
import axios from "axios";
import { VERSION } from "../../utils/constants/ApiUrl";
import {
  setAuthStatus,
  setVerifiedUserData,
} from "../../store/features/Auth.slice";

const AuthCallback = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const { setItem } = useLocalStorage();
  const token = searchParams.get("token");
  const error = searchParams.get("error");

  const errorMessage = error
    ? getAuthCallBackErrorMessage(error)
    : "Authentication failed. Please try again.";

  useEffect(() => {
    if (error) {
      console.log(error, "error");
      navigate("/", { state: { authError: errorMessage } });
      return;
    }

    if (!token) {
      return;
    }
    const user = decodeJwt(token);
    console.log(user); // or API call
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}${VERSION}auth/me/`,

        {
          headers: {
            Authorization: `Token ${token}`,
          },
        },
      )
      .then((response) => {
        const userData = response.data.data.user;
        dispatch(setAuthStatus(true));
        dispatch(
          setVerifiedUserData({
            id: userData.id,
            userEmail: userData.email,
            token: token,
          }),
        );
        setItem("user", JSON.stringify(userData));
        setItem("isAuthenticated", "true");
        setItem("token", token);
        navigate("/home");
      })
      .catch((error) => {
        console.error("Auth success call failed:", error);

      });
  }, []);

  return null;
};

export default AuthCallback;
